module.exports = __webpack_public_path__ + "img/symbol_4.e5e882b0.png";